import Color from "../../../assets/color/Color";
import { createPlatformStyles, theme } from "../../../theme/theme";

export const {styles, ids} = createPlatformStyles({
  mobile:{
    paymentStatusView: {
      width: "100%",
      padding: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      backgroundColor: theme.colors.policyStatus.paymentStatus,
    },
    paymentStatusText: {
      fontSize: theme.fontsize.reg,
      color: theme.colors.policyStatus.paymentStatusColor,
      fontStyle: "italic",
    },
    paymentIcon: { marginBottom: theme.spacing.cs },
    paymentDescriptionView: {
      alignItems: "center",
      paddingVertical: theme.spacing.xxl2,
    },
    paymentDescriptionText: {
      fontSize: theme.fontsize.reg,
      color: Color.background.textGray,
    },
  },
  web: {
    paymentStatusView: {
      width: "100%",
      padding: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      backgroundColor: theme.colors.policyStatus.paymentStatus,
    },
    paymentStatusText: {
      fontSize: theme.fontsize.reg,
      color: theme.colors.policyStatus.paymentStatusColor,
      fontStyle: "italic",
    },
    paymentIcon: { marginBottom: theme.spacing.cs, width:51, height:63 },
    paymentDescriptionView: {
      alignItems: "center",
      paddingVertical: theme.spacing.xxl2,
    },
    paymentDescriptionText: {
      fontSize: theme.fontsize.reg,
      color: Color.background.textGray,
    },
  }
});
